module.exports = __webpack_public_path__ + "static/media/3.c438f77d.png";